import React from "react";
import { Link } from "react-router-dom";
function ProductShopSection3() {
  return (
     <>
       <div className='container-fluid px-lg-5 px-2 bgg-col backSection14 py-3 backcolor1'>
        {/* Heading Row */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Body Massage Tools</h3>
          {/* <p className="text-dark mb-0 ">
            <span className="d-flex justify-content-between align-items-center gap-1 ">View All<Link to="/ProductsPage" className="text-decoration-none"><i className="bi bi-chevron-right viewAll" ></i></Link></span>
          </p> */}

        </div>

        {/* Product Cards */}

        <div className='row gapp'>
       <div className="col-6 col-sm-6 col-md-3 col-lg-3 mb-2">
      <div className="card custom-card">
        <div className="position-relative">
          <img src="/Images/Massage1.webp" className="card-img-top" alt="Avatar" />
          <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
            25% off
          </span>
        </div>
        <div className="card-body text-start">
          <h6 className="card-title mb-1 fw-bold">4Pc Moving Body Massage Cup <br></br> Silicon Body Massager Cup Set</h6>
          {/* <small className="mb-1 d-block">Silicon Body Massager Cup Set ( 4 size)</small> */}
    
          <div className="d-flex align-items-center justify-content-start gap-2 ">
            <p className="card-text fw-bold text-success mb-0">₹599</p>
            <small className="text-decoration-line-through text-muted">$800</small>
          </div>
    
          <div className="text-warning mb-1">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
          </div>
    
          <Link to="/DetailsPage" className="text-decoration-none mt-auto">
            <div className="bg-col text-white fw-semibold py-2 rounded d-flex justify-content-center align-items-center">
              Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
            </div>
          </Link>
        </div>
      </div>
        </div>
      <div className="col-6 col-sm-6 col-md-3 col-lg-3">
      <div className="card custom-card">
        <div className="position-relative">
          <img src="/Images/Massage2.webp" className="card-img-top" alt="Avatar" />
          <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
            25% off
          </span>
        </div>
        <div className="card-body text-start">
          <h6 className="card-title mb-1 fw-bold">Electric Accupressure Massage Pen Acu Pen</h6>
          {/* <small className="mb-1 d-block">Premium Quality Cupping Therapy Cup</small> */}
    
          <div className="d-flex align-items-center justify-content-start gap-2 ">
            <p className="card-text fw-bold text-success mb-0">₹380</p>
            <small className="text-decoration-line-through text-muted">$499</small>
          </div>
    
          <div className="text-warning mb-1">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
          </div>
    
          <Link to="/DetailsPage" className="text-decoration-none mt-auto">
            <div className="bg-col text-white fw-semibold py-2 rounded d-flex justify-content-center align-items-center">
              Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
            </div>
          </Link>
        </div>
      </div>
      </div>
    <div className="col-6 col-sm-6 col-md-3 col-lg-3">
      <div className="card custom-card">
        <div className="position-relative">
          <img src="/Images/Massage3.webp" className="card-img-top" alt="Avatar" />
          <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
            25% off
          </span>
        </div>
        <div className="card-body text-start">
          <h6 className="card-title mb-1 fw-bold">Deep Tissue IASTM Massage Tools 6 Pes Kit Stainless Steel</h6>
          {/* <small className="mb-1 d-block">Premium Quality Cupping Therapy Cup</small> */}
    
          <div className="d-flex align-items-center justify-content-start gap-2">
            <p className="card-text fw-bold text-success mb-0">₹5999</p>
            <small className="text-decoration-line-through text-muted">$7500</small>
          </div>
    
          <div className="text-warning mb-1">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
          </div>
    
          <Link to="/DetailsPage" className="text-decoration-none mt-auto">
            <div className="bg-col text-white fw-semibold py-2 rounded d-flex justify-content-center align-items-center">
              Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
            </div>
          </Link>
        </div>
      </div>
      </div>
      <div className="col-6 col-sm-6 col-md-3 col-lg-3">
      <div className="card custom-card">
        <div className="position-relative">
          <img src="/Images/Massage4.webp" className="card-img-top" alt="Avatar" />
          <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
            25% off
          </span>
        </div>
        <div className="card-body text-start">
          <h6 className="card-title mb-1 fw-bold">Natural Healing <br></br>| Moxa Cup | 6 Pes Set</h6>
          {/* <small className="mb-1 d-block">Premium Quality Cupping Therapy Cup</small> */}
    
          <div className="d-flex align-items-center justify-content-start gap-2 ">
            <p className="card-text fw-bold text-success mb-0">₹3049</p>
            <small className="text-decoration-line-through text-muted">$3250</small>
          </div>
    
          <div className="text-warning mb-1">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
          </div>
    
          <Link to="/DetailsPage" className="text-decoration-none mt-auto">
            <div className="bg-col text-white fw-semibold py-2 rounded d-flex justify-content-center align-items-center">
              Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
            </div>
          </Link>
        </div>
      </div>
      </div>
    </div>
    </div>
    
       </>
  );
}

export default ProductShopSection3;